import { familiesTypes } from "../constantes/actionTypes"

const initialState = []

export const families = (state = initialState, action) => {
    switch(action.type) {
        case familiesTypes.GET_ALL_FAMILIES_SUCCESS:
            return action.payload
        case familiesTypes.GET_ALL_FAMILIES_BY_SEARCH_SUCCESS:
            return state.concat(action.payload)
        case familiesTypes.NEW_FAMILY_SUCCESS:
            return [...state, action.payload]
        case familiesTypes.UPDATE_FAMILY_SUCCESS:
            const updateFamilies = state.map(item => {
                if (item.id_Articulo.toString() === action.payload.id_Articulo)
                    return action.payload
                return item
            })
            return updateFamilies
        case familiesTypes.DELETE_FAMILY_SUCCESS:
            return state.filter(item => item.id_Articulo !== action.payload)
        case familiesTypes.CLEAR_FAMILIES_LIST:
            return initialState
        case familiesTypes.NEW_FAMILY_FAILURE:
        case familiesTypes.UPDATE_FAMILY_FAILURE:
        case familiesTypes.DELETE_FAMILY_FAILURE:
            return state
        case familiesTypes.GET_ALL_FAMILIES_FAILURE:
        case familiesTypes.GET_ALL_FAMILIES_BY_SEARCH_FAILURE:
            return initialState
        default:
            return state
    }
}